import {defineStore} from 'pinia'
export const useCommonStore = defineStore({
    id: 'common',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        navHeight:36,
    }),
});